import HelpTooltip from 'components/help-tooltip';

interface FieldLabelProps {
    id?: string,
    dark?: boolean,
    large?: boolean,
    required?: boolean,
    help?: string,
    children: React.ReactNode
}

const FieldLabel = ({ id, dark = true, large, required, help, children }: FieldLabelProps) => {
    return (
        <label htmlFor={id} className={'field-label' + (dark ? ' dark' : '') + (large ? ' large' : '')}>
            { children }

            { required ? <span className="req"> *</span> : null }

            { help ? <HelpTooltip>{help}</HelpTooltip> : null }
        </label>
    )
}

export default FieldLabel;
